/** Shared first-run nav tour copy — web source of truth; mobile parity-tested. */

export type NavTourStepId =
  | 'home'
  | 'forums'
  | 'groups'
  | 'calendar'
  | 'blog'
  | 'feedback'
  | 'marketplace-enable'
  | 'marketplace'
  | 'theme';

export type NavTourStep = {
  id: NavTourStepId;
  title: string;
  body: string;
  /** web: sidebar anchor id; mobile: opens More menu when in overflow */
  anchor: 'sidebar' | 'settings-marketplace' | 'you-marketplace';
  webOnly?: boolean;
};

export const FEEDBACK_TOUR_BODY =
  'Suggest improvements and report bugs to the Communio team — not requests for your community host.';

const SOCIAL_STEPS: NavTourStep[] = [
  {
    id: 'home',
    title: 'Feed',
    body: 'Shared posts from your people — the main conversation of this community.',
    anchor: 'sidebar',
  },
  {
    id: 'forums',
    title: 'Forum',
    body: 'The same conversation as the Feed, shown as a board of recent posts.',
    anchor: 'sidebar',
  },
  {
    id: 'groups',
    title: 'Groups',
    body: 'Smaller circles inside the community (committees, cousins, project teams).',
    anchor: 'sidebar',
  },
  {
    id: 'calendar',
    title: 'Calendar',
    body: 'Events and dates everyone in this community can see.',
    anchor: 'sidebar',
  },
  {
    id: 'blog',
    title: 'Blog',
    body: 'Longer stories and guides that stay in the archive.',
    anchor: 'sidebar',
  },
  {
    id: 'feedback',
    title: 'Platform feedback',
    body: FEEDBACK_TOUR_BODY,
    anchor: 'sidebar',
  },
];

export const MARKETPLACE_ENABLE_STEP: NavTourStep = {
  id: 'marketplace-enable',
  title: 'Marketplace',
  body: 'Optional buy and sell for your community. Turn it on here when you are ready — sellers list items; buyers can checkout as guests.',
  anchor: 'settings-marketplace',
};

export const HOST_MARKETPLACE_NAV_STEP: NavTourStep = {
  id: 'marketplace',
  title: 'Marketplace',
  body: 'Your community shop — browse listings, orders, and seller tools.',
  anchor: 'sidebar',
};

export const MEMBER_MARKETPLACE_STEP: NavTourStep = {
  id: 'marketplace',
  title: 'Marketplace',
  body: 'Browse and buy from community sellers. Guest checkout is supported if you are not joining as a member.',
  anchor: 'sidebar',
};

export const THEME_STEP: NavTourStep = {
  id: 'theme',
  title: 'Theme',
  body: 'Colors and appearance for your account on this community.',
  anchor: 'sidebar',
  webOnly: true,
};

/** Base social steps shared by host and member tracks (before marketplace/theme). */
export const BASE_NAV_TOUR_STEPS = SOCIAL_STEPS;
